const tab_sections = {
    overview: 'Tổng quan',
    authentication: 'Xác thực',
    authorization: 'Phân quyền',
    users: 'Người dùng',
    developer: 'Nhà phát triển',
    tenant: 'Tenant',
};
export default Object.freeze(tab_sections);
